// extracted by mini-css-extract-plugin
export default {"menu":"Menu_menu__Sl1CZ","menuWrapper":"Menu_menuWrapper__rUonH"};